import {
    pageEvent,
    waitForAnalyticsLoad,
} from '@acko-tech/building-blocks.ui.acko-analytics';
import { useEffect } from 'react';

export const useSegmentViewEvents = (eventName: string, payload: any) => {
    useEffect(() => {
        waitForAnalyticsLoad().then(() => pageEvent(eventName, payload));
    }, []);
};
